module.exports = __webpack_public_path__ + "img/pocket entry length.a55502ec.png";